import { redirect } from '@tanstack/react-router'
import type { UserRole } from '@/constants/roleConstants'
import { ROUTES } from '@/constants/routeConstants'
import { getAuthSession } from '@/utils/apiAuthUtils.ts'

export const requireRoles =
  (allowedRoles: Array<UserRole> = []) =>
  (): void => {
    const session = getAuthSession()

    if (!session) {
      throw redirect({ to: ROUTES.ROOT })
    }

    if (
      allowedRoles.length > 0 &&
      !session.roles.some((role) => allowedRoles.includes(role as UserRole))
    ) {
      throw redirect({ to: ROUTES.MY_NETWORK })
    }
  }

export const requireAuth = requireRoles()

// Inverse de requireAuth : pour les pages réservées aux visiteurs non connectés
// (inscription par lien d'invitation). Un utilisateur déjà connecté est renvoyé
// vers son réseau, comme un rôle non autorisé dans requireRoles.
export const requireGuest = (): void => {
  if (getAuthSession()) {
    throw redirect({ to: ROUTES.MY_NETWORK })
  }
}
